(function () {
  const pickerSelector = '[data-variant-waitlist-picker]';

  function setOpen(picker, open) {
    const trigger = picker.querySelector('[data-waitlist-trigger]');
    const list = picker.querySelector('[data-waitlist-list]');
    if (!trigger || !list) return;

    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    list.hidden = !open;
  }

  function closeOtherPickers(activePicker) {
    document.querySelectorAll(pickerSelector).forEach(function (picker) {
      if (picker !== activePicker) setOpen(picker, false);
    });
  }

  function getProductData(picker) {
    const productJson = picker.querySelector('[data-waitlist-product-json]');
    if (!productJson) return null;

    try {
      return JSON.parse(productJson.textContent);
    } catch (error) {
      console.error('Unable to parse product data for STOQ.', error);
      return null;
    }
  }

  function openStoqModal(picker, variantId) {
    const productData = getProductData(picker);
    if (!productData || !variantId) return;

    const openModal = function () {
      if (!window._RestockRocket || typeof window._RestockRocket.openModal !== 'function') return false;
      window._RestockRocket.openModal(productData, String(variantId));
      return true;
    };

    if (!openModal()) {
      window.addEventListener('stoq:loaded', openModal, { once: true });
    }
  }

  function updateSelectionState(select) {
    const productSection = select.closest('.product-section');
    if (!productSection) return;

    const form = productSection.querySelector('.product-single__form');
    const cartButton = form && form.querySelector('[data-add-to-cart]');
    const cartButtonText = form && form.querySelector('[data-add-to-cart-text]');
    const error = productSection.querySelector('[data-variant-selection-error]');
    const picker = select.parentElement.querySelector(pickerSelector);
    const trigger = picker && picker.querySelector('[data-waitlist-trigger]');
    if (!form || !cartButton || !cartButtonText) return;

    if (select.value) {
      cartButton.removeAttribute('data-variant-selection-required');
      if (error) error.hidden = true;
      if (picker) picker.classList.remove('has-error');
      if (trigger) trigger.removeAttribute('aria-invalid');
      return;
    }

    cartButton.dataset.variantSelectionRequired = 'true';
    cartButton.disabled = false;
    cartButton.classList.remove('disabled');
    cartButtonText.textContent = cartButtonText.dataset.defaultText;
  }

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-waitlist-trigger]');
    if (trigger) {
      const picker = trigger.closest(pickerSelector);
      const isOpen = trigger.getAttribute('aria-expanded') === 'true';
      closeOtherPickers(picker);
      setOpen(picker, !isOpen);
      return;
    }

    const option = event.target.closest('[data-waitlist-option]');
    if (option) {
      const picker = option.closest(pickerSelector);
      const wrapper = picker.closest('.variant-input-wrap');
      const select = wrapper && wrapper.querySelector('[data-variant-dropdown-select]');
      if (!select) return;

      select.value = option.dataset.optionValue;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      updateSelectionState(select);
      setOpen(picker, false);
      picker.querySelector('[data-waitlist-trigger]').focus();
      return;
    }

    const notify = event.target.closest('[data-waitlist-notify]');
    if (notify) {
      const picker = notify.closest(pickerSelector);
      openStoqModal(picker, notify.dataset.variantId);
      setOpen(picker, false);
      return;
    }

    document.querySelectorAll(pickerSelector).forEach(function (picker) {
      if (!picker.contains(event.target)) setOpen(picker, false);
    });
  });

  document.addEventListener('change', function (event) {
    if (!event.target.matches('[data-variant-dropdown-select]')) return;
    const picker = event.target.parentElement.querySelector(pickerSelector);
    const triggerText = picker && picker.querySelector('[data-waitlist-trigger-text]');
    if (triggerText) triggerText.textContent = event.target.value || event.target.dataset.selectionPrompt;
  });

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.product-single__form');
    if (!form) return;

    const cartButton = form.querySelector('[data-variant-selection-required="true"]');
    if (!cartButton) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    const productSection = form.closest('.product-section');
    const error = productSection && productSection.querySelector('[data-variant-selection-error]');
    const picker = productSection && productSection.querySelector(pickerSelector);
    if (error) error.hidden = false;
    if (picker) {
      picker.classList.add('has-error');
      const trigger = picker.querySelector('[data-waitlist-trigger]');
      trigger.setAttribute('aria-invalid', 'true');
      trigger.focus();
    }
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(pickerSelector).forEach(function (picker) {
      const trigger = picker.querySelector('[data-waitlist-trigger]');
      const shouldRestoreFocus = trigger.getAttribute('aria-expanded') === 'true' && picker.contains(document.activeElement);
      setOpen(picker, false);
      if (shouldRestoreFocus) trigger.focus();
    });
  });

  document.addEventListener('focusin', function (event) {
    document.querySelectorAll(pickerSelector).forEach(function (picker) {
      if (!picker.contains(event.target)) setOpen(picker, false);
    });
  });
})();
